// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

const jquery = require('jquery')
window.jQuery = window.$ = jquery

import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import "@rails/actiontext"
import "trix"
import "../channels"

Rails.start()
ActiveStorage.start()

require('../components/assessment.js')
require('../components/assessments_table_init.jsx')
require('../components/image_carousel_init.jsx')
require('../components/flash_messages_init.jsx')
require('../facebook.js')
require('@popperjs/core')

import { createPopper } from '@popperjs/core'
import 'bootstrap'
import initSentry from '../sentry'

document.addEventListener('DOMContentLoaded', () => {
  initSentry()

  const account = document.querySelector('#account')
  const accountMenu = document.querySelector('#account-menu')
  
  if (account && accountMenu) {
    const popperInstance = createPopper(account, accountMenu, {
      placement: 'bottom-end',
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, 8],
          },
        },
      ],
    });

    function show() {
      accountMenu.setAttribute('data-show', '');
      popperInstance.update();
    }

    function hide() {
      accountMenu.removeAttribute('data-show');
    }

    account.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation(); // Prevent Bootstrap or other handlers
      if (accountMenu.hasAttribute('data-show')) {
        hide();
      } else {
        show();
      }
    });

    document.addEventListener('click', (e) => {
      if (accountMenu.hasAttribute('data-show') && !account.contains(e.target) && !accountMenu.contains(e.target)) {
        hide();
      }
    });
  }
});

// import Chart from 'chart.js'


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
